import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Grid, Accordion, AccordionDetails } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { TextField, AccordionSummary, H3 } from '~/components';
import { LedgerMappingItem, Product } from '~/types/products';
import { LedgerMappingView } from './LedgerMapping';

export const l = (key: string): string => `resources.solutions.products.ledgerMappings.${key}`;

interface LedgerMappingShowProps {
  record: Product;
}

const LedgerMappingShow = (props: LedgerMappingShowProps) => {
  const { record } = props;
  const translate = useTranslate();
  const t = (key: string): string => translate(l(key));
  const classes = useStyles();

  const [expanded, setExpanded] = useState<{ [x: string]: boolean }>({});
  const handleChange = (key: string, isExpanded: boolean) => () => {
    setExpanded((prevProps) => ({ ...prevProps, [key]: !isExpanded }));
  };

  const mappings: LedgerMappingItem[] = record?.ledgerMapping || [];
  if (mappings?.length === 0) return null;
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <H3>{t('ledgerMappings')}</H3>
        </Grid>
        {mappings?.map((item, index) => {
          const isExpanded = Boolean(expanded[`panel-${index}`]);
          return (
            <Grid key={index} item xs={12}>
              <Accordion
                expanded={isExpanded}
                onChange={handleChange(`panel-${index}`, isExpanded)}
              >
                <AccordionSummary
                  aria-controls={`${index}-content`}
                  id={`${index}-header`}
                  expanded={isExpanded}
                  heading={<TextField label={t('system')}>{item.system}</TextField>}
                />
                <AccordionDetails key='ledger-mapping-details' className={classes.AccordionDetails}>
                  <LedgerMappingView item={item} />
                </AccordionDetails>
              </Accordion>
            </Grid>
          );
        })}
      </Grid>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  AccordionDetails: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(3),
    display: 'block',
  },
}));

export default LedgerMappingShow;
